import { useTranslations } from 'next-intl';

export function useTradingHolidaysData() {
  const tr = useTranslations('pages.cfd.all.sections.markets.modal');

  return [
    {
      holidayName: tr.rich('row.0.title'),
      holidayDates: [tr.rich('row.0.date.0')],
    },
    {
      holidayName: tr.rich('row.1.title'),
      holidayDates: [tr.rich('row.1.date.0')],
    },
    {
      holidayName: tr.rich('row.2.title'),
      holidayDates: [tr.rich('row.2.date.0')],
    },
    {
      holidayName: tr.rich('row.3.title'),
      holidayDates: [
        tr.rich('row.3.date.0'),
        tr.rich('row.3.date.1'),
        tr.rich('row.3.date.2'),
        tr.rich('row.3.date.3'),
      ],
    },
    {
      holidayName: tr.rich('row.4.title'),
      holidayDates: [tr.rich('row.4.date.0')],
    },
    {
      holidayName: tr.rich('row.5.title'),
      holidayDates: [tr.rich('row.5.date.0')],
    },
    {
      holidayName: tr.rich('row.6.title'),
      holidayDates: [tr.rich('row.6.date.0')],
    },
    {
      holidayName: tr.rich('row.7.title'),
      holidayDates: [tr.rich('row.7.date.0')],
    },
    {
      holidayName: tr.rich('row.8.title'),
      holidayDates: [tr.rich('row.8.date.0')],
    },
    {
      holidayName: tr.rich('row.9.title'),
      holidayDates: [tr.rich('row.9.date.0')],
    },
    {
      holidayName: tr.rich('row.10.title'),
      holidayDates: [tr.rich('row.10.date.0')],
    },
    {
      holidayName: tr.rich('row.11.title'),
      holidayDates: [tr.rich('row.11.date.0')],
    },
    {
      holidayName: tr.rich('row.12.title'),
      holidayDates: [tr.rich('row.12.date.0')],
    },
    {
      holidayName: tr.rich('row.13.title'),
      holidayDates: [tr.rich('row.13.date.0')],
    },
    {
      holidayName: tr.rich('row.14.title'),
      holidayDates: [tr.rich('row.14.date.0')],
    },
    {
      holidayName: tr.rich('row.15.title'),
      holidayDates: [tr.rich('row.15.date.0')],
    },
    {
      holidayName: tr.rich('row.16.title'),
      holidayDates: [tr.rich('row.16.date.0')],
    },
    {
      holidayName: tr.rich('row.17.title'),
      holidayDates: [tr.rich('row.17.date.0')],
    },
    {
      holidayName: tr.rich('row.18.title'),
      holidayDates: [tr.rich('row.18.date.0')],
    },
    {
      holidayName: tr.rich('row.19.title'),
      holidayDates: [tr.rich('row.19.date.0')],
    },
    {
      holidayName: tr.rich('row.20.title'),
      holidayDates: [tr.rich('row.20.date.0')],
    },
    {
      holidayName: tr.rich('row.21.title'),
      holidayDates: [tr.rich('row.21.date.0')],
    },
    {
      holidayName: tr.rich('row.22.title'),
      holidayDates: [tr.rich('row.22.date.0')],
    },
    {
      holidayName: tr.rich('row.23.title'),
      holidayDates: [tr.rich('row.23.date.0')],
    },
    {
      holidayName: tr.rich('row.24.title'),
      holidayDates: [tr.rich('row.24.date.0')],
    },
    {
      holidayName: tr.rich('row.25.title'),
      holidayDates: [tr.rich('row.25.date.0')],
    },
    {
      holidayName: tr.rich('row.26.title'),
      holidayDates: [tr.rich('row.26.date.0')],
    },
    {
      holidayName: tr.rich('row.27.title'),
      holidayDates: [tr.rich('row.27.date.0')],
    },
    {
      holidayName: tr.rich('row.28.title'),
      holidayDates: [tr.rich('row.28.date.0')],
    },
    {
      holidayName: tr.rich('row.29.title'),
      holidayDates: [tr.rich('row.29.date.0')],
    },
    {
      holidayName: tr.rich('row.30.title'),
      holidayDates: [tr.rich('row.30.date.0')],
    },
    {
      holidayName: tr.rich('row.31.title'),
      holidayDates: [
        tr.rich('row.31.date.0'),
        tr.rich('row.31.date.1'),
        tr.rich('row.31.date.2'),
        tr.rich('row.31.date.3'),
        tr.rich('row.31.date.4'),
        tr.rich('row.31.date.5'),
      ],
    },
  ];
}
